export * from './get_interpolated_scene_set_with_id';
